
import { Dispatch, ReactElement, SetStateAction, useState } from "react";
import { FieldValues } from "react-hook-form";
import { Message } from "primereact/message";
import { classNames } from "primereact/utils";

import ComparisonTable from "./ComparisonTable";
import FormTypeSelector from "./FormTypeSelector";

import SvgWarningIcon from "./SvgWarningIcon";


type PropTyps = {
    isPublic:boolean;
    selectedForm: boolean;
    handleAddEmail?:(FormData:FieldValues) => void;
    onSelectHandler:Dispatch<SetStateAction<boolean>>;
    setFormTypeSelected:Dispatch<SetStateAction<boolean>>;
}

function SelectForm83bType(props: PropTyps): ReactElement {

    const {
        isPublic,
        selectedForm,
        handleAddEmail,
        onSelectHandler,
        setFormTypeSelected,
    } = props;

    const [isSelectFormShown, setSelectFormShown] = useState(false);

    return (
        <div className="w-full flex justify-content-center py-6">
            <div className={classNames("bg-white flex flex-column gap-6 p-6",{
                "w-10":!isPublic,
                "w-8":isPublic
            })}>
                <h1 className="text-3xl font-bold">
                    Which 83(b) Election Form Would You Like to Use?
                </h1>
                <p className="text-color text-lg font-normal">
                    Please select the type of 83(b) election form which you would like to use.
                    Each form supports certain entity and/or property types.  The entity and property
                    types supported by the freeform statement refer to the Corpora template.  
                    The IRS accepts both forms for purposes of making an 83(b) election.
                </p>
                <Message severity="warn" className="justify-content-start align-items-start gap-2 p-3 font-normal border-yellow-300 border-1 "
                    icon={<SvgWarningIcon/>}
                    text={() => {
                        return (
                            <div className="font-normal text-lg">
                                Reminder: &nbsp;You have <strong>30 days</strong> from the date of transfer of your property 
                                (such as your grant date) to file your 83(b) election with the IRS.  To ensure timely 
                                performance of our service, we have a <strong className="underline">strict internal cut-off of 14 days</strong> – orders are
                                accepted until 11:59pm UTC on the 14th day after the date of transfer.
                            </div>
                        )
                    }}
                />
                <div className="w-full flex flex-column gap-4">
                    <div className="flex ">
                        <div className="flex bg-gray-100 border-round px-2 py-1 gap-1">
                            <button
                                onClick={() => setSelectFormShown(false)}
                                className={classNames("px-3 py-2 cursor-pointer p-component font-semibold text-lg", { "p-card": !isSelectFormShown })}>
                                Select Form
                            </button>
                            <button
                                onClick={() => {
                                    setSelectFormShown(true);
                                    onSelectHandler(true);
                                }}
                                className={classNames("px-3 py-2 cursor-pointer p-component font-semibold text-lg", { "p-card": isSelectFormShown })}>
                                Compare Forms
                            </button>
                        </div>
                    </div>
                   
                    {
                        !isSelectFormShown ? (
                            <FormTypeSelector 
                                setFormTypeSelected={setFormTypeSelected}
                                onSelect={onSelectHandler}
                                isRegualarSelected={selectedForm}
                                isPublic={isPublic}
                                handleAddEmail={handleAddEmail} />
                        ) : (
                            <ComparisonTable />
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default SelectForm83bType